export interface Month {
  name: string
  number: number
}

export const Months = Object.freeze({
  JANUARY: { name: 'January', number: 1 },
  FEBRUARY: { name: 'February', number: 2 },
  MARCH: { name: 'March', number: 3 },
  APRIL: { name: 'April', number: 4 },
  MAY: { name: 'May', number: 5 },
  JUNE: { name: 'June', number: 6 },
  JULY: { name: 'July', number: 7 },
  AUGUST: { name: 'August', number: 8 },
  SEPTEMBER: { name: 'September', number: 9 },
  OCTOBER: { name: 'October', number: 10 },
  NOVEMBER: { name: 'November', number: 11 },
  DECEMBER: { name: 'December', number: 12 }
}) as Record<string, Month>

const nameToNumberMap = new Map(
  Object.values(Months).map(m => [m.name.toLowerCase(), m.number])
)

const numberToNameMap = new Map(
  Object.values(Months).map(m => [m.number, m.name])
)

export function getMonthNumber (monthName: string): number {
  if (monthName === null || typeof monthName !== 'string') return -1
  return nameToNumberMap.get(monthName.toLowerCase()) ?? -1
}

export function getMonthName (monthNumber: string | undefined): string | undefined {
  if (monthNumber === null || monthNumber === undefined) return undefined

  const num = typeof monthNumber === 'string'
    ? parseInt(monthNumber, 10)
    : monthNumber

  if (typeof num !== 'number' || isNaN(num)) return undefined
  return numberToNameMap.get(num) ?? undefined
}

export function getMonthByNumber (monthNumber: number | null | undefined): Month | null {
  if (monthNumber === null || monthNumber === undefined) return null
  return Object.values(Months).find(month => month.number === monthNumber) ?? null
}
